import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import dayjs from 'dayjs';

import { IconsModule } from 'src/app/core/icons/icons.module';
import { PhonePipe } from 'src/app/core/pipes/pipes/phone.pipe';
import { QuoteSteps } from 'src/app/shared/constants/quote-steps.constant';
import { AbstractPageForm } from 'src/app/shared/page-classes/page-form.abstract';

@Component({
    selector: 'pkd-footer',
    imports: [RouterModule, IconsModule, PhonePipe],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent extends AbstractPageForm {
	@Input() useAltFooter = false;

	public footerClasses: string[] = [];

	constructor(private router: Router) {
		super();
	}

	get footerClass() {
		return this.footerClasses.join(' ');
	}

	get year() {
		return dayjs().year();
	}

	get agentName() {
		return this.promoCode.agent.name;
	}

	get address() {
		if (!this.promoCode.agent.eCommerceWebsite?.contactAddress1) {
			return '';
		}

		return (
			`${this.promoCode.agent.eCommerceWebsite?.contactAddress1}` +
			`${this.promoCode.agent.eCommerceWebsite?.contactAddress2 ? ' ' + this.promoCode.agent.eCommerceWebsite?.contactAddress2 : ''}` +
			`, ${this.promoCode.agent.eCommerceWebsite?.contactCity}, ${this.promoCode.agent.eCommerceWebsite?.contactState?.stateShort} ` +
			`${this.promoCode.agent.eCommerceWebsite?.contactZipCode}`
		);
	}

	get logo() {
		const type =
			this.promoCode.agent.eCommerceWebsite?.footerLogoAttachment.contentType +
			'/' +
			this.promoCode.agent.eCommerceWebsite?.footerLogoAttachment.contentSubType;
		return 'data:' + type + ';base64, ' + this.promoCode.agent.eCommerceWebsite?.footerLogoAttachmentBase64.response;
	}

	public goSmartBegin() {
		this.router.navigate(['/']);
		this.appStateService.goToStep(QuoteSteps.SMART_BEGIN);
	}
}
